import React from 'react';
import { styled } from '@mui/material';
import { CheckCircle } from '@mui/icons-material';
import { Colors } from 'library';

interface RAvatarProps {
    imageUrl?: string | null;
    initials: string;
    size?: number;
    verified?: boolean;
    color?: string;
    onClick?: () => void;
}

export function RAvatar({ imageUrl, initials, size = 44, verified, color, onClick }: RAvatarProps) {
    const fontSize = Math.round(size * 0.32);
    const hasImage = !!imageUrl;

    return (
        <Container
            onClick={onClick}
            style={{
                width: size,
                height: size,
                fontSize,
                backgroundColor: hasImage ? undefined : color ?? Colors.lightGrey,
                color: color ? Colors.white : Colors.darkNavy,
                border: hasImage && color ? `3px solid ${color}` : undefined,
                cursor: onClick ? 'pointer' : 'default',
            }}
        >
            {hasImage ? <Image src={imageUrl} alt={initials} /> : initials}
            {verified && (
                <VerifiedBadge>
                    <CheckCircle sx={{ fontSize: Math.round(size * 0.32), color: Colors.turquoise }} />
                </VerifiedBadge>
            )}
        </Container>
    );
}

const Container = styled('div')({
    borderRadius: '50%',
    backgroundColor: Colors.lightGrey,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontWeight: 600,
    color: Colors.darkNavy,
    position: 'relative',
    overflow: 'visible',
    flexShrink: 0,
});

const Image = styled('img')({
    width: '100%',
    height: '100%',
    borderRadius: '50%',
    objectFit: 'cover',
});

const VerifiedBadge = styled('div')({
    position: 'absolute',
    bottom: -2,
    right: -2,
    backgroundColor: Colors.white,
    borderRadius: '50%',
    display: 'flex',
});
